// extracted by mini-css-extract-plugin
export default {"spinner":"Preloader_spinner__p1sZd","animate":"Preloader_animate__bqueW"};